module.exports = __webpack_public_path__ + "static/media/point-1.a1c92bc5.svg";